import { Resolution } from 'src/components/conversation/src/components/types';

import { Link } from './link';
import { PullRequest } from './pull-request';
import { Commit } from './refs';
import { RenderedContent } from './rendered-content';
import { User } from './user';

type BBCommentInline = {
  to: number | null | undefined;
  from: number | null | undefined;
  path: string;
};

type Comment = {
  content: RenderedContent;
  created_on: Date;
  deleted: boolean;
  extra: {
    likes: User[];
    isActive?: boolean;
  };
  id: number;
  inline?: BBCommentInline;
  links: {
    self: Link;
    html: Link;
  };
  parent?: {
    id: number;
    links: {
      self: Link;
      html: Link;
    };
  };
  type: 'pullrequest_comment' | 'commit_comment';
  updated_on: Date | null | undefined;
  user: User | null | undefined;
  resolution?: Resolution;
};

type CommentCommit = {
  commit: Commit;
};

type CommentPR = {
  pullrequest: PullRequest;
  type: 'pullrequest_comment';
};

type BBCommitComment = Comment & CommentCommit;
type BBPullRequestComment = Comment & CommentPR;
type BBCommentType = BBCommitComment | BBPullRequestComment;

declare global {
  namespace BB {
    type CommitComment = BBCommitComment;
    type PullRequestComment = BBPullRequestComment;
    type CommentType = BBCommentType;
    type CommentInline = BBCommentInline;
  }
}

export type CommitComment = BBCommitComment;
export type PullRequestComment = BBPullRequestComment;
export type CommentType = BBCommentType;
export type CommentInline = BBCommentInline;
